import {Injectable} from '@angular/core';
import {Router} from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class AdminNavigationService {

    constructor(private router: Router) {
    }

    public goToHome(): Promise<boolean> {
        return this.router.navigate(['/']);
    }

    public goToLogin(): Promise<boolean> {
        return this.router.navigate(['/auth/login']);
    }

    public goToAdminHome(): Promise<boolean> {
        return this.router.navigate(['/']);
    }

    public goToDeviceNotificationsIdExport(): Promise<boolean> {
        return this.router.navigate(['/notificationsIdExport']);
    }

    public goToImportCSVPatients(): Promise<boolean> {
        return this.router.navigate(['/importCSVPatients']);
    }

    public goToSendAppNotifications(): Promise<boolean> {
        return this.router.navigate(['/sendAppNotifications']);
    }

    public goToAccounts(query?: string): Promise<boolean> {
        if (query) {
            return this.router.navigate(['/accounts'], {queryParams: {query}});
        } else {
            return this.router.navigate(['/accounts']);
        }
    }

    public goToAccount(accountCode: string, ): Promise<boolean> {
        return this.router.navigate(['/accounts', accountCode]);
    }

    public goToAccountAddSubscription(accountCode: string, ): Promise<boolean> {
        return this.router.navigate([`/accounts/${accountCode}/subscriptions/add`]);
    }

    public goToFindLatestUsageOfSensors(sensors?: string, serialCode?: string, email?: string): Promise<boolean> {
        if (sensors) {
            return this.router.navigate(['/findSensorLatestUsage'],
                {queryParams: {sensors}});
        } else if (serialCode && email) {
            return this.router.navigate(['/findSensorLatestUsage'],
                {queryParams: {serialCode, email}});
        } else {
            return this.router.navigate(['/findSensorLatestUsage']);
        }
    }

    public goToFindProductionLogsOfSensor(sensor?: string, startDate?: number, endDate?: number): Promise<boolean> {
        return this.router.navigate(['/findSensorProductionLogs'],
            {queryParams: {sensor, startDate, endDate}});
    }

    public goToFindSensorActivityHistory(sensor?: string): Promise<boolean> {
        return this.router.navigate(['/findSensorActivityHistory'],
            {queryParams: {sensor}});
    }

    public goToReportHome(): Promise<boolean> {
        return this.router.navigate(['/recentAccountActivityReportOverview']);
    }

    public goToReportHomeTableView(): Promise<boolean> {
        return this.router.navigate(['/recentAccountActivityReportOverview/viewTable']);
    }

    public goToPaymentReportHome(): Promise<boolean> {
        return this.router.navigate(['/recentAccountPaymentsReport']);
    }

    public goToDevPlayground(): Promise<boolean> {
        return this.router.navigate(['/dev']);
    }
}
